module.exports = __webpack_public_path__ + "img/1.952996d5.png";